export default __webpack_public_path__ + "static/media/male.67b9f37d.svg";